import search from "../../assets/serviceOfferingIcons/search.svg";
import location from "../../assets/serviceOfferingIcons/location.svg";
import window from "../../assets/serviceOfferingIcons/window.svg";
import faq from "../../assets/processIcons/faq.svg";
import prescription from "../../assets/processIcons/prescription.svg";
import cart from "../../assets/processIcons/cart.svg";
import logo1 from "../../assets/trust/EU Logo quer grau.svg";
import logo2 from "../../assets/trust/Startup Verband grau.svg";
import logo3 from "../../assets/trust/Tagesspiegel grau.svg";
import logo4 from "../../assets/trust/EU Logo quer.svg";
import logo5 from "../../assets/trust/Startup Verband.svg";
import logo6 from "../../assets/trust/Tagesspiegel.svg";
// import logom1 from "../../assets/trust/Senovation grau.png";
// import logom2 from "../../assets/trust/Seniorenportal grau.png";
// import logom3 from "../../assets/trust/Apotheken Umschau grau.png";

const state = {
  currentIndexSF: 0,
  cardsDesktop: [
    {
      title: "Produkte entdecken",
      description:
        "Ich weiß noch nicht was ich brauche und möchte mir einen Überblick über mögliche Hilfsmittel verschaffen.",
      button: "Beratung starten",
      img: window,
      link: {
        name: "Beratung"
      },        
    },
    {
      title: "Informationen einholen",
      description: "Ich habe bereits einige Produkte gefunden und würde mich gerne näher informieren.",
      button: "Hilfsmittel suchen",
      img: search,
      link: {
        name: "catalogStartScreen"
      },    
    },
    {
      title: "Anbieter finden",
      description:
        "Ich suche einen passenden Anbieter, der mich möglichst schnell mit den richtigen Hilfsmitteln versorgt.",
      button: "Anbieter finden",
      img: location,
      link: {
        name: "SelectionPageApp"
      }
    },
  ],
  cardsMobile: [
    {
      title: "Informationen einholen",
      description: "Ich habe bereits einige Produkte gefunden und würde mich gerne näher informieren.",
      button: "Hilfsmittel suchen",
      img: search,
      link: {
        name: "catalogStartScreen"
      },
    },
    {
      title: "Anbieter finden",
      description:
        "Ich suche einen passenden Anbieter, der mich möglichst schnell mit den richtigen Hilfsmitteln versorgt.",
      button: "Anbieter finden",
      img: location,
      link: {
        name: "SelectionPageApp"
      }
    },
  ],
  currentIndexP: 0,
  processesDesktop: [
    {
      number: 1,
      icon: faq,
      title: "Bedarf ermitteln",
      content:
        "Wenn Sie passende Hilfsmittel für Ihre Situation finden wollen, dann ist unsere digitale Beratung das Richtige für Sie. Sie bekommen dabei auf Basis einiger Angaben zum Gesundheitszustand und Wohnumfeld geeignete Hilfsmittel vorgeschlagen. So können Sie schnell passende Hilfsmittel finden.",
      button: "Beratung starten",
      link: {
        name: "Beratung"
      },      
    },
    {
      number: 2,
      icon: prescription,
      title: "Kostenübernahme klären",
      content:
        "Wenn Sie herausfinden möchten, welche Kosten in Ihrer Situation übernommen werden können, dann erhalten Sie hier schnell einen Überblick. Sie werden nicht nur bei der Einholung von Verordnungen, sondern auch bei der Befüllung notwendiger Anträge unterstützt.",
      button: "Ratgeber öffnen",
      link: {
        externalURL: "https://ratgeber.anni.care/alles-zur-verordnung-von-hilfsmitteln-auf-rezept/"
      }
    },
    {
      number: 3,
      icon: cart,
      title: "Hilfsmittel erhalten",
      content:
        "Wenn Sie bereits wissen, welche Hilfsmittel Sie benötigen, dann finden Sie mit unserer Unterstützung ganz einfach den richtigen Anbieter in Ihrer Nähe. So bekommen Sie Ihre Hilfsmittel auf dem schnellsten Weg und haben immer einen kompetenten Ansprechpartner in Ihrer Umgebung.",
      button: "Anbieter finden",
      link: {
        name: "SelectionPageApp"
      },      
    },
  ],
  processesMobile: [
    {
      number: 1,
      icon: faq,
      title: "Bedarf ermitteln",
      content:
        "Wenn Sie passende Hilfsmittel für Ihre Situation finden wollen, dann ist unsere Beratung das Richtige für Sie. Sie bekommen dabei auf Basis einiger Angaben zum Gesundheitszustand und Wohnumfeld geeignete Hilfsmittel vorgeschlagen. So können Sie schnell passende Hilfsmittel finden.",
      button: "Beratung starten",
      link: {
        externalURL: "tel:+493052001258"
      }
    },
    {
      number: 2,
      icon: prescription,
      title: "Kostenübernahme klären",
      content:
        "Wenn Sie herausfinden möchten, welche Kosten in Ihrer Situation übernommen werden können, dann erhalten Sie hier schnell einen Überblick. Sie werden nicht nur bei der Einholung von Verordnungen, sondern auch bei der Befüllung notwendiger Anträge unterstützt.",
      button: "Ratgeber öffnen",
      link: {
        externalURL: "https://ratgeber.anni.care/alles-zur-verordnung-von-hilfsmitteln-auf-rezept/"
      }
    },
    {
      number: 3,
      icon: cart,
      title: "Hilfsmittel erhalten",
      content:
        "Wenn Sie bereits wissen, welche Hilfsmittel Sie benötigen, dann finden Sie mit unserer Unterstützung ganz einfach den richtigen Anbieter in Ihrer Nähe. So bekommen Sie Ihre Hilfsmittel auf dem schnellsten Weg und haben immer einen kompetenten Ansprechpartner in Ihrer Umgebung.",
        button: "Anbieter finden",
        link: {
          name: "SelectionPageApp"
        }
    },
  ],
  currentIndexT: 0,
  testimonials: [
    {
      id: 1,
      text: "Ich möchte mich bei Ihnen und Ihrer Firma für die sehr prompte Bestellung und Lieferung des Rollstuhls meiner Frau bedanken, den sie aufgrund eines Unfalls benötigt. Sehr herzliche Kommunikation und Hilfsbereitschaft Ihrerseits. Ein herzliches Dankeschön von uns.",
      customer: "Herr Komarnitski",
      location: "Berlin",
    },
    {
      id: 2,
      text: "Es hat alles geklappt mit dem Kinder-Rollstuhl und war sehr zufrieden.",
      customer: "Frau Peterson",
      location: "Berlin",
    },
    {
      id: 3,
      text: "Sie sind wirklich zu empfehlen. Sie gebe ich gerne weiter. Sie sind wirklich eine große Hilfe.",
      customer: "Herr Huhn",
      location: "Berlin",
    },
  ],
  currentIndexTrust: 0,
  trust: [
    {
      disabled: logo1,
      active: logo4,
    },
    {
      disabled: logo3,
      active: logo6,
    },
    {
      disabled: logo2,
      active: logo5,
    },
  ],
};
const getters = {
  currentIndexSF: (state) => state.currentIndexSF,
  cardsMobile: (state) => state.cardsMobile,
  cardsDesktop: (state) => state.cardsDesktop,
  //processes
  processesDesktop: (state) => state.processesDesktop,
  processesMobile: (state) => state.processesMobile,
  currentIndexP: (state) => state.currentIndexP,
  //testimonials
  testimonials: (state) => state.testimonials,
  currentIndexT: (state) => state.currentIndexT,
  //trust
  trust: (state) => state.trust,
  currentIndexTrust: (state) => state.currentIndexTrust,
};
const mutations = {
  nextIndex: (state) => {
    if (state.currentIndexSF < state.cards.length - 1) state.currentIndexSF++;
  },
  prevIndex: (state) => {
    if (state.currentIndexSF > 0) state.currentIndexSF--;
  },
  //processes
  nextIndexP: (state) => {
    if (state.currentIndexP < state.processes.length - 1) state.currentIndexP++;
  },
  
  prevIndexP: (state) => {
    if (state.currentIndexP > 0) state.currentIndexP--;
  },
  //testimonials
  nextIndexT: (state) => {
    if (state.currentIndexT < state.testimonials.length - 1) state.currentIndexT++;
  },
  
  prevIndexT: (state) => {
    if (state.currentIndexT > 0) state.currentIndexT--;
  },
  //trust
  nextIndexTrust: (state) => {
    if (state.currentIndexTrust < state.trust.length - 1) state.currentIndexTrust++;
  },
  
  prevIndexTrust: (state) => {
    if (state.currentIndexTrust > 0) state.currentIndexTrust--;
  },
};
export default {
  state,
  getters,
  mutations,
};
